// Constants TypeScript files should be AUTO-GENERATED by the Typewriter Visual Studio plugin. Do not modify this file.
enum EventCategory {
    Comm = 1,
    Ac = 2,
    Amp = 3,
    Cn = 4,
    Sensor = 5,
    Ops = 6,
    Limit = 7,
}
export default EventCategory;
